export class AgencyGroupUserRoles {
  static readonly SuperUser = 'SuperUser';
  static readonly Marketing = 'Marketing';
  static readonly Finance = 'Finance';
  static readonly Agent = 'Agent';
  static readonly SmartCommissionAdministrator = 'SmartCommissionAdministrator';
}
